export default __webpack_public_path__ + "static/media/Marathi_af_1.b9e31251.mp3";